globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Emailing = appCustomerSpace.Controllers.Emailing || {};

appCustomerSpace.Controllers.Emailing.RecurringSettingsContentController = (function (superClass) {

  utils.extend(RecurringSettingsContentController, superClass);

  function RecurringSettingsContentController() {
    return RecurringSettingsContentController.__super__.constructor.apply(this, arguments);
  }

  function upcaseFirst(value) {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  $.extend(RecurringSettingsContentController.prototype, {
    initSubjectPreview: function () {
      var $input = $('[data-subject-input]');
      if (!$input.length) return;

      var variableExamples = $input.data('variable-examples') || {};
      var $preview = $('[data-subject-preview]');
      if (!$preview.length) return;

      var $previewText = $preview.find('[data-subject-preview-text]');

      function refresh() {
        var value = $input.val() || '';
        if (!value.match(/%\{[A-Za-z_]+\}/)) {
          $preview.addClass('hidden');
          return;
        }
        var interpolated = value.replace(/%\{[A-Za-z_]+\}/g, function (match) {
          return variableExamples[match] != null ? variableExamples[match] : '';
        });
        $previewText.text(upcaseFirst(interpolated));
        $preview.removeClass('hidden');
      }

      $input.on('input', refresh);
    }
  });

  return RecurringSettingsContentController;

})(appCustomerSpace.Controllers.Emailing.MainController);
